import React from 'react';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import CheckboxTree from 'react-checkbox-tree';
import './CkBoxTree.css';

const Icon = ({ name }) => <i className="md-icon ckbox-tree-icon">{name}</i>;

export default (props) => (
  <CheckboxTree
    {...props}
    icons={{
      check: <Icon name="check_box" />,
      uncheck: <Icon name="check_box_outline_blank" />,
      halfCheck: <Icon name="indeterminate_check_box" />,
      expandClose: <i className="md-icon">expand_less</i>,
      expandOpen: <i className="md-icon">expand_more</i>,
      expandAll: <span className="rct-icon rct-icon-expand-all" />,
      collapseAll: <span className="rct-icon rct-icon-collapse-all" />,
      parentClose: <i className="md-icon">folder</i>,
      parentOpen: <i className="md-icon">folder_open</i>,
      leaf: <i className="md-icon">insert_drive_file</i>,
    }}
  />
);
